export const getColumnNumber = (
  activeColumns: object,
  placeCheckbox = true,
  placeSettings = true,
) => {
  let c = 0;
  if (placeCheckbox) {
    c += 1;
  }
  if (placeSettings) {
    c += 1;
  }

  Object.values(activeColumns).forEach((value) => {
    if (value) {
      c += 1;
    }
  });

  return c;
};
